import React from "react";
import { X, AlertTriangle } from "lucide-react";

export default function DeleteItemModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
  itemName
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal-card">

        <button className="modal-close" onClick={onClose} disabled={loading}>
          <X size={18} />
        </button>

        <div className="delete-icon">
          <AlertTriangle size={40} color="#dc2626" />
        </div>

        <h3>Delete Item</h3>

        <p>
          Are you sure you want to delete{" "}
          <strong>{itemName}</strong>?
        </p>

        <p className="delete-warning">
          This action cannot be undone.
        </p>

        <div className="delete-actions">
          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="confirm-delete-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>

      </div>
    </div>
  );
}